module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "z-cell",
    attrs: {
      "href": _vm.url
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_c('div', {
    staticClass: "z-cell__title"
  }, [_vm._t("icon", [(_vm.icon) ? _c('i', {
    staticClass: "zui-icon",
    class: 'zui-icon-' + _vm.icon
  }) : _vm._e()]), _vm._v(" "), _vm._t("title", [_c('span', {
    staticClass: "z-cell__text",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), (_vm.label) ? _c('span', {
    staticClass: "z-cell__label",
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }) : _vm._e()])], 2), _vm._v(" "), _c('div', {
    staticClass: "z-cell__value",
    class: {
      'is-link': _vm.isLink
    }
  }, [_vm._t("default", [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.value)
    }
  })])], 2), _vm._v(" "), (_vm.isLink) ? _c('i', {
    staticClass: "zui-icon zui-icon-arrow"
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-78cd79e1!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/cell/src/cell.vue
// module id = 142
// module chunks = 2 3